module.exports = __webpack_public_path__ + "img/banner_AboutUs1_Mobile.c1abe5b8.png";